import React, { useEffect } from "react";
import { AlertTriangle, XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const WarningPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#422216] to-[#160a07] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#2a160e]/90 backdrop-blur-sm rounded-2xl border border-[#e9c17b]/40 shadow-2xl p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center">
            <AlertTriangle size={48} className="text-red-400" />
          </div>
        </div>

        <h1 className="text-2xl md:text-3xl font-bold text-[#f2deb0] mb-4">
          Developer Tools Detected
        </h1>

        <p className="text-[#e4cfaa] mb-6">
          Please close Developer Tools to continue using the application. This
          helps protect our content and ensures the best experience.
        </p>

        <div className="bg-[#1e0e0a]/80 rounded-lg p-4 mb-6">
          <p className="text-sm text-[#e4cfaa]/70">
            Press F12 or right-click → Inspect to close Developer Tools
          </p>
        </div>

        <button
          onClick={() => navigate("/")}
          className="px-6 py-2 bg-gradient-to-r from-[#e9c17b] to-[#d4a853] text-[#1e0e0a] font-semibold rounded-lg hover:scale-105 transition-transform"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default WarningPage;
